export enum Components {
  SETTINGS = "SETTINGS",
  ADD_USER = "ADD_USER",
  EDIT_USER = "EDIT_USER",
  ADD_PATIENT = "ADD_PATIENT",
  EDIT_PATIENT = "EDIT_PATIENT",
  ADD_INSOLE_MODEL = "ADD_INSOLE_MODEL",
  EDIT_INSOLE_MODEL = "EDIT_INSOLE_MODEL",
  ADD_INSOLE_PAIR = "ADD_INSOLE_PAIR",
  EDIT_INSOLE_PAIR = "EDIT_INSOLE_PAIR",
  PATIENT_INFO = "PATIENT_INFO",
  ADD_ZONE = "ADD_ZONE",
  SAVE_ZONE_PRESET = "SAVE_ZONE_PRESET",
  EXPORT_INSOLE = "EXPORT_INSOLE",
}
